import { Injectable, Inject } from '@angular/core';
import { DataService } from '../../../core/service/base/data.service';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { HttpClient } from '@angular/common/http';
import { AccountPlanDimensions } from '../../model/account-plan-dimensions';
import { Observable, map } from 'rxjs';

@Injectable()
export class AccountPlanDimensionsService extends DataService<AccountPlanDimensions> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, AccountPlanDimensions, progressBar, 'account-plan-dimensions');
  }

  getCompanySettings(companyId: string): Observable<AccountPlanDimensions> {
    return this.client.get<AccountPlanDimensions>(`${this.endpoint}/company/${companyId}`).pipe(map(item => this.createModel(item)));
  }
}
